/* eslint-disable max-lines */
import { css } from 'linaria';

export const headerSection = css`
  width: 100%;
  margin-bottom: 70px;

  @media (--to-desktop) {
    margin-bottom: 80px;
  }

  @media (--only-mobile) {
    margin-bottom: 56px;
  }
`;

export const itemText = css`
  @media (--to-desktop) {
    font-size: 16px;
    line-height: 22px;
  }
`;

export const textWrapper = css`
  width: 880px;
  margin-bottom: 48px;

  @media (--to-desktop) {
    margin-bottom: 40px;
  }

  @media (--only-tablet) {
    width: 567px;
  }

  @media (--only-mobile) {
    width: 100%;
    margin-bottom: 24px;
  }
`;

export const header = css`
  && {
    margin-bottom: 24px;

    @media (--only-mobile) {
      margin-bottom: 16px;
      font-size: 48px;
      line-height: 56px;
    }
  }
`;

export const headerContent = css`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  @media (--to-desktop) {
    flex-direction: column;
  }
`;

export const video = css`
  width: 730px;
  height: 450px;

  @media (--only-desktop) {
    width: 580px;
    height: 357px;
  }

  @media (--to-desktop) {
    width: 100%;
    height: 407px;
    margin-bottom: 40px;
  }

  @media (--only-mobile) {
    height: 50vw;
    margin-bottom: 24px;
  }
`;

export const descriptionBlock = css`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 380px;

  @media (--only-desktop) {
    width: 320px;
  }

  @media (--to-desktop) {
    width: 100%;
  }
`;

export const list = css`
  padding: 0;
  list-style-type: none;

  @media (--to-desktop) {
    margin: 0;
  }

  @media (--only-tablet) {
    display: flex;
    flex-wrap: wrap;
    margin-bottom: 32px;
  }
`;

export const listItem = css`
  position: relative;
  min-height: 44px;
  padding-left: 72px;
  margin-bottom: 24px;

  &::before {
    position: absolute;
    top: 0;
    left: 0;
    width: 60px;
    height: 48px;
    background-repeat: no-repeat;
    background-position: 50%;
    background-size: contain;
    content: '';

    @media (--to-desktop) {
      width: 50px;
      height: 40px;
    }

    @media (--only-mobile) {
      width: 40px;
      height: 34px;
    }
  }

  @media (--only-mobile) {
    margin-bottom: 16px;
  }

  @media (--only-tablet) {
    width: 358px;
    padding: 0 66px 32px 62px;
    margin-bottom: 0;

    &:nth-child(even) {
      width: 292px;
      padding: 0 0 32px 62px;
    }

    &:nth-child(n + 3) {
      padding-bottom: 0;
    }
  }
`;

export const varietyItem = css`
  &::before {
    background-image: url('https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/spaceo-storage/header/variety.png/variety.png');
  }
`;

export const qualityItem = css`
  &::before {
    background-image: url('https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/spaceo-storage/header/quality.png/quality.png');
  }
`;

export const easyItem = css`
  &::before {
    background-image: url('https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/spaceo-storage/header/easy.png/easy.png');
  }
`;

export const rangeItem = css`
  &::before {
    background-image: url('https://cdn.lemanapro.ru/lmru/image/upload/f_auto,q_90,c_pad,b_auto,d_photoiscoming.png/fudzi/elbrus/images/landings/spaceo-storage/header/range.png/range.png');
  }
`;

export const seeAllButton = css`
  @media (--only-tablet) {
    && {
      width: 296px;
    }
  }
`;

export const smallText = css`
  && {
    @media (--only-mobile) {
      display: block;
      margin-bottom: 4px;
      font-weight: 500;
      font-size: 20px;
      line-height: 26px;
    }
  }
`;
